// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_bRi","cls2":"SearchBox-cls2_5PE SearchBox-cls1_bRi"};